import { render, staticRenderFns } from "./SMS.vue?vue&type=template&id=24fdf3f5&"
import script from "./SMS.js?vue&type=script&lang=js&"
export * from "./SMS.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports